module.exports = __webpack_public_path__ + "static/img/v70-2.5d09648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v70-2.png
// module id = 1z5Z
// module chunks = 1